import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ShowAllUsers } from "../../../../context/Slice/RegisterSlice";
import { UpdEventCoordinator } from "../../../../context/Slice/EventManagementSlice";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import './ChangeCoordinator.css'
import {
    Button 
  } from "@mui/material";

const ChangeCoordinator = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { selectedEvent } = location.state || {};
    const allUsers = useSelector((state) => state.RegisterR.AlluserData);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedCoordinator, setSelectedCoordinator] = useState(null);
    console.log('--->',selectedEvent)
    useEffect(() => {
        dispatch(ShowAllUsers());
    }, [dispatch]);

    const HandleBack = () => {
        navigate("/admin-dashboard/EventMaster");
      };
    

    useEffect(() => {
        if (Array.isArray(allUsers)) {
            const filteredUsers = allUsers.filter(user => user.role === 'co-ordinator');
            setFilteredData(filteredUsers);
        }
    }, [allUsers]);

    const handleCoordinatorChange = (event) => {
        const selectedId = event.target.value;
        const coordinator = filteredData.find(user => user.id === selectedId);
        setSelectedCoordinator(coordinator);
    };

    const handelSubmit = (event) => {
        event.preventDefault();
        console.log("submit",selectedCoordinator)
        dispatch(UpdEventCoordinator({ID:selectedEvent.id,CoordinatorID:selectedCoordinator.id,PreviousCoordinatorID:selectedEvent.Coordinator.id}))
    };

    return (
        <div id='ChangeCoordinator'>
            <div className='mt-5 mb-5'>
            <Button
              variant="contained"
              color="secondary"
              onClick={HandleBack}
              sx={{ position: "absolute", top: "20px", left: "20px" }}
            >
              Back
            </Button>
                <h2 className="heading">Change The Event Co-ordinator </h2>

            </div>
            <div className='col-12 row mt-5 justify-content-between'>
                <div className='col-4'>
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title fw-bold">Previous Co-ordinator Details </h5>
                            <p className="card-text"><strong>Name:</strong> {selectedEvent.Coordinator.firstName} {selectedEvent.Coordinator.lastName}</p>
                            <p className="card-text"><strong>Email:</strong> {selectedEvent.Coordinator.email}</p>
                            <p className="card-text"><strong>Mobile:</strong> {selectedEvent.Coordinator.mobile_number} </p>
                        </div>
                    </div>
                </div>
                <div className='col-4'>
                    <form   onSubmit={handelSubmit} style={{ width: '26rem' }}>
                        <div data-mdb-input-init className="form-outline mb-4">
                            <label className="form-label fs-4" htmlFor="coordinatorSelect">Select Co-ordinator</label>
                            <select id="coordinatorSelect" className="form-control" onChange={handleCoordinatorChange}>
                                <option value="">Select</option>
                                {filteredData.map(coordinator => (
                                    <option key={coordinator.id} value={coordinator.id}>
                                        {coordinator.firstName} {coordinator.lastName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {selectedCoordinator && (
                            <>
                                <div data-mdb-input-init className="form-outline mb-4">
                                    <label className="form-label fs-4" htmlFor="coordinatorName">Name</label>
                                    <input type="text" id="coordinatorName" className="form-control" value={`${selectedCoordinator.firstName} ${selectedCoordinator.lastName}`} readOnly />
                                </div>

                                <div data-mdb-input-init className="form-outline mb-4">
                                    <label className="form-label fs-4" htmlFor="coordinatorEmail">Email</label>
                                    <input type="text" id="coordinatorEmail" className="form-control" value={selectedCoordinator.email} readOnly />
                                </div>

                                <div data-mdb-input-init className="form-outline mb-4">
                                    <label className="form-label fs-4" htmlFor="coordinatorMobile">Mobile Number</label>
                                    <input type="text" id="coordinatorMobile" className="form-control" value={selectedCoordinator.mobile_number} readOnly />
                                </div>
                            </>
                        )}

                        <button type="submit" className="btn btn-primary btn-block mb-4">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ChangeCoordinator;
